import { render } from "./ico-setting.vue?vue&type=template&id=9d159428&scoped=true"
const script = {}

import "./ico-setting.vue?vue&type=style&index=0&id=9d159428&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d159428"]])

export default __exports__